import CommentSummary from "./CommentSummary";

export default CommentSummary;
